import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { ButtonStyle } from '@constants/button/1.0';
import { MessageType } from '@constants/message/1.0';
import { MessageComponent } from '@components/message/1.0/message.component';
import { ButtonComponent } from '@components/button/1.0/button.component';

const appState = { target: 'role-routing' };

@Component({
  selector: 'txp-auth-error',
  templateUrl: './auth-error.component.html',
  styleUrls: ['./auth-error.component.scss'],
  host: { class: 'txp-auth-error' },
  standalone: true,
  imports: [MessageComponent, ButtonComponent],
})
export class AuthErrorComponent implements OnInit {
  messageType = MessageType;
  buttonStyle = ButtonStyle;
  errorDescription: string | null = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    const params = this.activatedRoute.snapshot.queryParams;
    this.errorDescription =
      params['error_description'] ||
      params['auth_error_description'] ||
      'The user does not have access to this application.';
  }

  loginFresh() {
    this.authService.loginWithRedirect({
      appState,
      authorizationParams: { prompt: 'login' },
    });
  }
}
